import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { FetaureGrouper } from '@core/models/piramide/FeatureGrouper';
import { environment } from '@environments/environment';
import { PiramidalService } from './piramidal.service';
import { catchError, combineLatest, map, Observable, of, shareReplay, tap } from 'rxjs';
import { Product } from '@core/models/piramide/Product';
import { BrandsService } from './brands.service';
import { Subcategory } from '@core/models/piramide/Subcategory';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  public fullDataSignal = signal<Product[]>([]);
  public readonly fullData$ = combineLatest([
    this._piramidalService.products.observable,
    this._piramidalService.subcategoriesGroupers.observable,
    this._piramidalService.subcategories.observable.pipe(
      catchError((e) => of([] as Subcategory[])),
    ),
    this._piramidalService.subcategoryBanner.observable,
    this._brandsService.brands$,
    this._piramidalService.featuresProduct.observable,
  ]).pipe(
    map(([products]) => products),
    tap((products) => this.fullDataSignal.set(products)),
    shareReplay(),
  );

  public readonly products$ = this.fullData$.pipe(
    map((rawProducts) => rawProducts.filter((p) => p.id_categoria !== 3 && p.precioEspecial > 0)),
  );
  public readonly productsIdx = signal<Record<number, Product>>({});
  public readonly productsIdx$: Observable<Record<number, Product>> = this.products$.pipe(
    map((products) =>
      products.reduce((idx, p) => {
        idx[p.id_producto] = p;
        return idx;
      }, {}),
    ),
    tap((idx) => {
      console.log('idx', idx);

      this.productsIdx.set(idx);
    }),
    shareReplay(),
  );

  indiceAgrup: any;
  agrupadores: FetaureGrouper;
  caracteristicas: any[];
  indiceCar: any;

  constructor(
    private _http: HttpClient,
    private _piramidalService: PiramidalService,
    private _brandsService: BrandsService,
  ) {}

  public getByGrouper(products: Array<Product>, id: number): Array<Product> {
    return products.filter((p) => p.$subcategory?.id_agrupador == id);
  }

  public getCaract(caract: any, agrup: any): any {
    this.indiceAgrup = {};
    agrup.forEach((ag) => {
      this.indiceAgrup[ag.id] = ag;
      ag.$caracteristicas = [];
    });
    this.indiceCar = {};
    this.caracteristicas = caract.sort((a, b) => a.ondenAgrupador - b.ondenAgrupador);
    this.caracteristicas.forEach((car) => {
      if (car.valor) {
        this.indiceCar[car.id] = car;
        this.indiceAgrup[car.id_agrupador].$caracteristicas.push(car);
      }
    });
    return (this.agrupadores = agrup.filter((el) => {
      return el.$caracteristicas.length > 0;
    }));
  }

  public armarURLold(index: any): any {
    const initial = index.split('?');
    return initial[0].split('_').slice(-1)[0];
  }

  public getCombos(): Observable<any[]> {
    return this._http.get<any[]>(`${environment.apiStatic}productos_combos`);
  }
}
